var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSbbSwapDirection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SBB_11_swap",
    focusable: "false",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 16.4l-3.8 3.9-3.9-3.9.7-.7 2.6 2.6v-11c0-1.2-1-2.2-2.2-2.2s-2.2 1-2.2 2.2v9.4c0 1.8-1.5 3.2-3.2 3.2S6 18.5 6 16.7v-11L3.4 8.4l-.8-.8 3.8-3.9 3.9 3.9-.7.8L7 5.7v11c0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2V7.3c0-1.8 1.5-3.2 3.2-3.2S18 5.5 18 7.3v11l2.6-2.7.8.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbbSwapDirection);
export default __webpack_public_path__ + "static/media/sbb_swap_direction.e7668020b903fdee2f3b9c0bc4ce1b41.svg";
export { ForwardRef as ReactComponent };